import React from "react";
import { useTranslation as useI18nextTranslations } from "react-i18next";
import { LocaleRepo } from "./TranslationContext";

export const useTranslationsRepo = (localeStrings: any): LocaleRepo => {
  const { t, i18n } = useI18nextTranslations("website2.website");

  const getValue = (path: string, defaultValue?: string) => t(`website2.website:${path}`, { defaultValue });

  const getCurrentLocale = () => i18n.language;

  return {
    getValue,
    getCurrentLocale,
    getLanguages: () => localeStrings.allLanguages,
  };
};
